<template>
    <div v-if="hasData">
        <HistoryRedeemUseItem
            v-for="(campaign) in list"
            :key="campaign.id"
            :campaign="campaign"
            @onClick="clickPurchase(campaign)"
        ></HistoryRedeemUseItem> 
 
    </div>
    <div v-else class="">  
        <NoData></NoData>
    </div>
</template>

<script>
import { CampaignType } from '@/helper/StaticValue.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/Locale.js';
import ConfigManager from '@/config/ConfigManager.js';
import Util from '@/helper/Utility.js';
import NoData from '@/module/History/component/NoData.vue';

//controller
import { DetailController } from '../../../../Detail/controller/DetailController';
//component
import HistoryRedeemUseItem from '../Item/HistoryRedeemUseItem.vue' 
//import Unlock from '@/module/Detail/modal/SerialModal/component/Unlock.vue';

export default {
    name: 'HistoryRedeemUse',
    props:{
        list: Array,
        modalController: Object
    },
    components:{
        HistoryRedeemUseItem, 
        NoData,
        //Unlock
    },
    computed:{
        hasData: function(){
            return this.list.length
        }
    },
    data: function() {
        return {
            isSerialLoading: false,
            campaignConfig: null,
            purchases: [],
            detailController: new DetailController(),
        };
    },

    created() {
        this.initialIsFromLanding();
        //console.log('HistoryRedeemUse', this.list);
    },

    methods: { 
        complete: function() {
            console.log('complete');
            this.$emit('useSerial');
        },
        initialIsFromLanding: function () {
            //console.log(this.$route);
            let backCount = this.$route.query.back;
            if (Util.isNumber(backCount) && backCount != 0) {
                this.$router.go(backCount);
                //console.log('router go : ' + backCount);
            }
        },
        //#region action history
        clickPurchase: function (purchase) {
            //check internet stuff.
            if (this.isSerialLoading) {
                console.log(1)
                return;
            }

            // this.clickedIndex = index;

            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                console.log(2)
                return;
            }
            if (purchase.minutesValidAfterUsed) { 
                this.clickGetRedeem(purchase); 
            }
            else { 
                this.openSerial(purchase);
            } 
        },

        clickGetRedeem: function (purchase) {
            //console.log('clickUse', purchase);
            this.isSerialLoading = true;
            this.modalController.loadingModal.show();
            BzbsHistory.apiGetRedeem(purchase.redeemKey).subscribe((result) => {
                this.isSerialLoading = false; 
                purchase.updateAfterRedeem(result);
 
                // mark as used
                purchase.isUsed = true;
                //console.log('purchase', purchase);
                if (this.isShowSerialModal(purchase)) {
                    // this.busSerialModal.$emit('showSerialModal', purchase);
                    this.openSerial(purchase);
                }
            
                this.modalController.loadingModal.hide();
            }, (err) => {
                this.isSerialLoading = false;
                console.log(err);
                this.modalController.loadingModal.hide();
            });
        },
        
        clickUse: function (purchase) {
            //console.log('clickUse', purchase);
            this.isSerialLoading = true;
            this.modalController.loadingModal.show();
            BzbsHistory.apiRedeemUse(purchase.redeemKey).subscribe((result) => {
                this.isSerialLoading = false; 
                purchase.updateAfterRedeem(result);
 
                // mark as used
                purchase.isUsed = true;
                //console.log('purchase', purchase);
                if (this.isShowSerialModal(purchase)) {
                    // this.busSerialModal.$emit('showSerialModal', purchase);
                    this.openSerial(purchase);
                }
            
                this.modalController.loadingModal.hide();
            }, (err) => {
                this.isSerialLoading = false;
                console.log(err);
                this.modalController.loadingModal.hide();
            });
        },

        openSerial: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            //console.log('open serial');
            this.modalController.serialModal
                    .clearModal()
                    .setSerial(serialModel)
                    .setHideBtn()
                    .show();
            this.modalController.serialModal.onUseSerial(() => {
                //console.log('use serial');
                this.clickUse(purchase);
            });
            this.modalController.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
        },

        openInterfaceHistory: function(purchase) {
            var sToken = Account.getTokenShuffle();
            var locale = Locale.getLocaleCode();
            var header = 'false';
            var theme = ConfigManager.getAppName();
            let historyCount = this.getHistoryCount(purchase);
            let returnUrl = window.location.origin + '/history/redeem?tab=redeem&back=' + historyCount;
            returnUrl = encodeURIComponent(returnUrl);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == 'link') {
                var url = purchase.privilegeMessage;

                url = url.replace('<campaign_id>', purchase.id);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + returnUrl;
                console.log(url)
                window.location.replace(url);
                return;
            }

            // old default landing interface
            if (purchase.website && purchase.website.indexOf('starbucks') > 0) {
                let url = purchase.website +
                        '&token=' + sToken +
                        '&locale=' + locale +
                        '&RedeemKey=' + purchase.redeemKey +
                        '&header=' + header +
                        '&theme=' + theme +
                        '&return_url=' + returnUrl; // ReturnUrl;
                window.location.replace(url);
                console.log(url)
            } else if (purchase.website && purchase.website.indexOf('linesticker') > 0) {
                let url = purchase.website
                        + "&info2=" + purchase.info2
                        + "&info3=" + purchase.info3
                        + "&locale=" + locale
                        + "&return_url=" + encodeURIComponent(window.location.href)
                        + "&token=" + sToken
                        + "&is_history=true";
                window.location.replace(url);
                console.log(url)
            }
        },

        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') {
                return false;
            }
            if (purchase.expireIn && purchase.expireIn <= 0) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },

        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },
        //#endregion action history
        getHistoryCount: function(purchase){
            if (purchase.website && purchase.website.indexOf('starbucks') > 0) {
                return -2;
            } else {
                return 0;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.line{
    height: 0.5px;
    transform: rotate(-180deg);
}
</style>
